exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1V4WOIAtH5yecCkQvs16Ph{margin-bottom:30px}._1V4WOIAtH5yecCkQvs16Ph ._2MaPWWH-ZafKRMLx-v6fLA{display:flex;justify-content:flex-end}._1V4WOIAtH5yecCkQvs16Ph ._2ddUBd7wWe4-KTcSGcnWXW{flex:2 0 auto}._1V4WOIAtH5yecCkQvs16Ph ._3Ow-BOXhv8nbXuHNbLDnmp{display:inline-block;flex:1 0 auto;text-align:right;margin-left:15px}\n", ""]);

// Exports
exports.locals = {
	"TripLaps": "_1V4WOIAtH5yecCkQvs16Ph",
	"metrics": "_2MaPWWH-ZafKRMLx-v6fLA",
	"eleGain": "_2ddUBd7wWe4-KTcSGcnWXW",
	"distance": "_3Ow-BOXhv8nbXuHNbLDnmp"
};